import React from 'react';
import { Link } from 'react-router-dom';
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <Link to="/" className="group flex items-center gap-3" aria-label="Ancrages — retour à l’accueil" data-id="element-179" data-mp="8v67134ab2be">
      <span aria-hidden="true" className={`flex h-9 w-9 items-center justify-center border font-serif text-lg ${inverted ? 'border-paper/40 text-paper' : 'border-ink text-ink'}`} data-id="element-180" data-mp="3q7qexh2834gp">
        A
      </span>
      <span className="flex flex-col leading-none" data-id="element-181" data-mp="rs7dythefchz">
        <span className={`font-serif text-xl tracking-tight ${inverted ? 'text-paper' : 'text-ink'}`} data-id="element-182" data-mp="rpl6etuicwzr">
          Ancrages
        </span>
        <span className={`mt-1 text-[11px] ${inverted ? 'text-paper/60' : 'text-muted'}`} data-id="element-183" data-mp="ht8adpbhq71u">
          Habitat & renouvellement urbain
        </span>
      </span>
    </Link>;
}